<div class="acute py-3">

  <div class="acute-form">
    <div class="mb-4" [formGroup]="manualForm">
      <!-- Patient Name -->
      <div class="row">
        <div class="col">
          <input type="text" class="form-control w-100 marginl" placeholder="Search patient" [matAutocomplete]="auto"
            formControlName="patient" (blur)="onPatientblur()" />
          <mat-autocomplete #auto="matAutocomplete">
            <div class="w-100 h-100 d-flex align-items-center justify-content-center loader" *ngIf="progress_spinner">
              <span class="purpleLoader"></span>
            </div>
            <mat-option *ngFor="let patient of patientList" [value]="patient.name" (click)="onSelect(patient)">
              <span>
                {{ patient.name }} |
                {{ patient.email }}
                <ng-container *ngIf="
                    patient.providerName !== null &&
                    patient.providerName !== undefined
                  ">
                  | {{ patient.providerName == 'normal' ? 'Email' : patient.providerName}}
                </ng-container>
              </span>
            </mat-option>
            <!-- No data found option -->
            <mat-option *ngIf="!progress_spinner && patientList.length === 0" disabled>
              No data found
            </mat-option>
          </mat-autocomplete>
          <span class="text-danger" *ngIf="!isPatientvalid">Patient is not available.</span>
        </div>
        <div class="col-auto" *ngIf="tenant != 'wylo'">
          <button (click)="onClear()" class="custom-btn bt-right">
            Clear Search
          </button>
        </div>
      </div>
      <div class="row">
        <!-- Patient Address -->
        <div class="col-4 mt-3">
          <div class="form-group">
            <label class="small white-space pb-1">Patient Address</label> <span class="text-danger">*</span>
            <mat-form-field>
              <mat-select class="form-control width" placeholder="Select Address"
                [formControl]="manualForm.get('address')">
                <mat-option *ngFor="let address of addressList" [value]="address.shipping_address"
                  (click)="onSelectAddress(address)">
                  {{ address.shipping_address }}
                </mat-option>
                <!-- Add Address option -->
                <div class="add_optionBg">
                  <mat-option (click)="openAddModal(selectedUserId)" *ngIf="manualForm.get('patient').value">
                    <div class="d-flex align-items-center text-success f-semibold justify-content-center ">
                      <span _ngcontent-qhx-c296="" class="material-icons mr-2"> add </span> Add Address
                    </div>
                  </mat-option>
                </div>
              </mat-select>
            </mat-form-field>
            <mat-autocomplete #address="matAutocomplete">
              <div class="w-100 h-100 d-flex align-items-center justify-content-center loader" *ngIf="progress_spinner">
                <span class="purpleLoader"></span>
              </div>
            </mat-autocomplete>
          </div>
        </div>

        <!-- Shipping Type Dropdown -->
        <div class="col-4 mt-3">
          <div class="form-group">
            <label class="small white-space pb-1">Patient Type</label> <span class="text-danger">*</span>
            <mat-form-field>
              <mat-select class="form-control width" placeholder="Select Patient Type" formControlName="shippingType"
                (selectionChange)="onShippingTypeChange($event)">
                <mat-option value="chronic">Chronic</mat-option>
                <mat-option value="acute">Acute</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="col-4 mt-3" *ngIf="IsNursingDDActive && isForQc">
          <div class="form-group">
            <label class="small white-space pb-1">Nursing Home</label> <span class="text-danger">*</span>
            <mat-form-field>
              <mat-select formControlName="search_value" class="form-control" placeholder="Select Nursing Home">
                <mat-option *ngFor="let homes of nursingHomes" [value]="homes.ID" (click)="onSelectNursing(homes)">{{
                  homes.Name }}</mat-option>
                <mat-option (click)="openAddNursingHomeModal()"> Add Nursing Home </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <h2 class="mb-0">Rx Details</h2>
    <div class="card shadow-sm RxDetail my-2" *ngFor="let Addon of AddOnInfoData; let i = index">
      <div class="card-header border-0" id="headingOne">
        <div class="row">
          <div class="col">
            <h3 class="mb-0">Rx Number {{ Addon.ID }}</h3>
          </div>
          <div class="col-auto text-right">
            <div class="d-flex rxBtnGroup">
              <button (click)="toggleCollapse(Addon.ID)" class="btn btn-secondary btn-sm mr-2 material-icons primary-gray"
              [attr.aria-expanded]="
                    isCollapsed[Addon.ID] ? 'true' : 'false'
                  " [attr.aria-controls]="'collapse_' + Addon.ID">
                  <span class="material-icons"> keyboard_arrow_down </span>
            </button>
            <button type="button" class="btn btn-warning btn-sm material-icons" (click)="EditRx(i)">
              <span class="material-icons"> edit_icon </span>
            </button>

            <button type="button" class="btn btn-danger btn-sm bt-right ml-2" (click)="RemoveRxDetail(i)">
              <span class="material-icons"> close </span>
            </button>
            </div>
          </div>
        </div>
        <h5 class="mb-0"></h5>
      </div>

      <div [id]="'collapse_' + Addon.RxId" class="collapse" [ngClass]="{ show: isCollapsed[Addon.ID] }">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Original Rx Number</label>
                <label class="form-control">{{Addon.OrigRxNum}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Rx Number</label>
                <label class="form-control">{{Addon.ID}}</label>
              </div>
            </div>
          </div>
          <hr />

          <h3>Drug Details</h3>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">DIN</label>
                <label class="form-control">{{Addon.kroll_drg.DIN}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Drug</label>
                <label class="form-control" placeholder="0-9">{{Addon.kroll_drg.BrandName}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Strength</label>
                <input type="text" class="form-control" placeholder="Strength" [value]="Addon.kroll_drg.Strength" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Form</label>
                <label class="form-control" placeholder="0-9">{{Addon.kroll_drg.Form}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Schedule</label>
                <label class="form-control" placeholder="0-9">{{Addon.kroll_drg.Schedule}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Instructions</label>
                <label class="form-control" placeholder="0-9">{{Addon.kroll_drg.Instructions}}</label>
              </div>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Auth Qty</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.AuthQty}}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Available Qty</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.AvailableQty}}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Dispatch Qty.</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.DispQty}}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Remaining Qty</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.RemQty}}</label>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Last filled Qty</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.Lastfilledqty}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Next fill Qty</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.NextFillQty}}</label>
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label class="small white-space pb-1">Auto refill</label><br />
                <mat-slide-toggle [checked]="Addon.AutoRefill == 1"></mat-slide-toggle>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Days Supply Qty</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.DaysSupply}}</label>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">First Filled date</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.FirstFillDate | date}}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Last Filled date</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.LastFillDate | date}}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Fill date</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.FillDate | date}}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Fill Expiry Date</label>
                <label class="form-control" placeholder="Auth Qty">{{Addon.FillExpiryDate | date}}</label>
              </div>
            </div>
          </div>
          <hr />

          <h3>Payment Detail</h3>
          <div class="row">
            <!-- <div class="col-md-3">
                  <div class="form-group">
                    <label class="small white-space pb-1">AAC</label>
                    <input type="number" class="form-control" [value]="Addon.AAC" />
                  </div>
                </div> -->
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Cost</label>
                <label type="number" class="form-control">{{Addon.Cost}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Markup</label>
                <label type="number" class="form-control">{{Addon.Markup}}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Fee</label>
                <label type="number" class="form-control">{{Addon.Fee}}</label>
              </div>
            </div>

            <!-- <div class="col-md-3">
                  <div class="form-group">
                    <label class="small white-space pb-1">Base Cost</label>
                    <input type="number" class="form-control" [value]="Addon.BaseCost" />
                  </div>
                </div> -->

            <!-- <div class="col-md-4">
                  <div class="form-group">
                    <label class="small white-space pb-1">Discount Cost</label>
                    <input type="number" class="form-control" [value]="Addon.DiscountCost" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="small white-space pb-1">Discount Markup</label>
                    <input type="number" class="form-control" [value]="Addon.DiscountMarkup" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="small white-space pb-1">Discount Fee</label>
                    <input type="number" class="form-control" [value]="Addon.DiscountFee" />
                  </div>
                </div> -->
          </div>
          <hr />

          <h3>Insurance Details</h3>
          <div class="row">
            <div class="col-md-6">
              <table class="table border">
                <thead>
                  <th>Sub plan</th>
                  <th>Pays</th>
                </thead>
                <tbody>
                  <tr *ngFor="
                          let Insurance of Addon.Insurancedata;
                          let i = index
                        ">
                    <td>{{ Insurance.subplanname }}</td>
                    <td>{{ Insurance.pays }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>


  <form [formGroup]="AddOnInfo">
    <div class="card RxDetail">
      <div class="card-body">
        <div class="row" *ngIf="IsRxEditMode">
          <div class="col-md-3">
            <h2>Edit Rx</h2>
            <hr>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="small white-space pb-1">Original Rx Number</label> <span class="text-danger">*</span>
              <input type="text" class="form-control" placeholder="Original Rx Number" formControlName="OrignalRxId"
                (blur)="checkrxid(2)" />
              <span class="text-danger" *ngIf="IfORxIdValid">Original Rx Number alredy exists.</span>
              <mat-error class="ml-3" *ngIf="
                  AddOnInfo.controls['OrignalRxId'].touched &&
                  (AddOnInfo.controls['OrignalRxId'].hasError('required') ||
                    AddOnInfo.controls['OrignalRxId'].hasError('pattern') ||
                    AddOnInfo.controls['OrignalRxId'].hasError('min'))
                ">
                <ng-container *ngIf="AddOnInfo.controls['OrignalRxId'].hasError('required')">Original Rx Number
                  required</ng-container>
                <ng-container *ngIf="AddOnInfo.controls['OrignalRxId'].hasError('pattern')">Original Rx Number must be a
                  positive integer</ng-container>
                <ng-container *ngIf="AddOnInfo.controls['OrignalRxId'].hasError('min')">Original Rx Number must be
                  greater than or equal to
                  1</ng-container>
              </mat-error>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label class="small white-space pb-1">Rx Number</label> <span class="text-danger">*</span>
              <input type="text" class="form-control" placeholder="Rx Number" formControlName="RxId"
                (blur)="checkrxid(1)" />
              <span class="text-danger" *ngIf="IfRxIdValid">Rx Number alredy exists.</span>
              <mat-error class="ml-3" *ngIf="
                  AddOnInfo.controls['RxId'].touched &&
                  (AddOnInfo.controls['RxId'].hasError('required') ||
                    AddOnInfo.controls['RxId'].hasError('pattern') ||
                    AddOnInfo.controls['RxId'].hasError('min'))
                ">
                <ng-container *ngIf="AddOnInfo.controls['RxId'].hasError('required')">Rx Number required</ng-container>
                <ng-container *ngIf="AddOnInfo.controls['RxId'].hasError('pattern')">Rx Number must be a positive
                  integer</ng-container>
                <ng-container *ngIf="AddOnInfo.controls['RxId'].hasError('min')">Rx Number must be greater than or equal
                  to 1</ng-container>
              </mat-error>
            </div>
          </div>
          <div class="col-auto mt-1">
            <label>&nbsp;</label><br />
            <button type="button" class="btn btn-sm custom-btn ms-0" (click)="ValidateRx()">
              Add Rx details
            </button>
          </div>
          <div class="col-auto mt-1">
            <label>&nbsp;</label><br />
            <button type="button" class="btn btn-sm custom-btn ms-0" (click)="clearRx()">
              Clear Rx
            </button>
          </div>
        </div>

        <div *ngIf="IsRxsValid" class="border-top pt-3 mt-2">
          <h3>Drug Details</h3>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">DIN</label> <span class="text-danger">*</span>
                <input type="text" class="form-control w-100" placeholder="Search DIN" [matAutocomplete]="autoDIN"
                  formControlName="DIN" (blur)="onDrugblur()" />
                <mat-autocomplete #autoDIN="matAutocomplete">
                  <div class="w-100 h-100 d-flex align-items-center justify-content-center loader"
                    *ngIf="progress_spinner">
                    <span class="purpleLoader"></span>
                  </div>
                  <mat-option *ngFor="let drugdatas of DINList" [value]="drugdatas.id" (click)="onSelectDIN(drugdatas)">
                    {{ drugdatas.din }}
                  </mat-option>
                  <mat-option *ngIf="!progress_spinner && drugList.length === 0" disabled>
                    No DIN found
                  </mat-option>
                  <div class="add_optionBg">
                    <mat-option (click)="openAddModalDrug()" *ngIf="manualForm.get('patient').value">
                      <div class="d-flex align-items-center text-success f-semibold justify-content-center ">
                        <span _ngcontent-qhx-c296="" class="material-icons mr-2"> add </span> Add Drug
                      </div>
                    </mat-option>
                  </div>
                </mat-autocomplete>
                <mat-error class="ml-3"
                  *ngIf="AddOnInfo.controls['DIN'].touched &&AddOnInfo.controls['DIN'].hasError('required')">
                  <ng-container *ngIf="AddOnInfo.controls['DIN'].hasError('required')">DIN required</ng-container>
                </mat-error>
                <mat-error class="ml-3"
                  *ngIf="AddOnInfo.controls['DIN'].touched &&AddOnInfo.controls['DIN'].hasError('pattern')">
                  Please enter a positive number.
                </mat-error>
                <span class="text-danger ml-3" *ngIf="!isDrugvalid && !AddOnInfo.controls['DIN'].hasError('required')">Din is not available.</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Drug</label> <span class="text-danger">*</span>
                <input type="text" class="form-control w-100" placeholder="Search Drug" [matAutocomplete]="autodrug"
                  formControlName="DrugName" (blur)="onDrugblur()" />
                <mat-autocomplete #autodrug="matAutocomplete">
                  <div class="w-100 h-100 d-flex align-items-center justify-content-center loader"
                    *ngIf="progress_spinner">
                    <span class="purpleLoader"></span>
                  </div>
                  <mat-option *ngFor="let drugdatas of drugList" [value]="drugdatas.id"
                    (click)="onSelectDrug(drugdatas)">
                    {{ drugdatas.name }}
                  </mat-option>

                  <mat-option *ngIf="!progress_spinner && drugList.length === 0" disabled>
                    No Drug found
                  </mat-option>

                  <div class="add_optionBg">
                    <mat-option (click)="openAddModalDrug()" *ngIf="manualForm.get('patient').value">
                      <div class="d-flex align-items-center text-success f-semibold justify-content-center ">
                        <span _ngcontent-qhx-c296="" class="material-icons mr-2"> add </span> Add Drug
                      </div>
                    </mat-option>
                  </div>
                  <!-- <mat-option (click)="openAddModalDrug()">Add Drug</mat-option> -->
                </mat-autocomplete>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DrugName'].touched &&
                    AddOnInfo.controls['DrugName'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['DrugName'].hasError('required')">Drug required</ng-container>
                </mat-error>
                <span class="text-danger ml-3" *ngIf="!isDrugvalid && !AddOnInfo.controls['DrugName'].hasError('required')">Drug is not available.</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Strength</label> <span class="text-danger">*</span>
                <input type="text" class="form-control" placeholder="Strength" formControlName="Strength" />

                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Strength'].touched &&
                    AddOnInfo.controls['Strength'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['Strength'].hasError('required')">Strength
                    required</ng-container>
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Form</label> <span class="text-danger">*</span>
                <input type="text" class="form-control" placeholder="Form" formControlName="Form" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Form'].touched &&
                    AddOnInfo.controls['Form'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['Form'].hasError('required')">Form required</ng-container>
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Schedule</label>
                <!-- <span class="text-danger">*</span> -->
                <input type="text" class="form-control" placeholder="Schedule" formControlName="Dosage" />
                <!-- <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Dosage'].touched &&
                    AddOnInfo.controls['Dosage'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['Dosage'].hasError('required')">Schedule
                    required</ng-container>
                </mat-error> -->
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Instructions</label>
                <input type="text" class="form-control" placeholder="Instructions" formControlName="Instructions" />
              </div>
            </div>
          </div>
          <hr />

          <h3>Qty. & Amount</h3>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Auth Qty</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" placeholder="Auth Qty" formControlName="Authqty"
                  (blur)="CalculateRemaningQty()" (focusout)="setAvailableQty()" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Authqty'].touched &&
                    AddOnInfo.controls['Authqty'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['Authqty'].hasError('required')">Auth Qty
                    required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Authqty'].touched &&
                    AddOnInfo.controls['Authqty'].hasError('pattern')
                  ">
                  Please enter a positive number.
                </mat-error>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Available Qty</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" placeholder="Available Qty" formControlName="AvailableQty"
                  (blur)="CalculateRemaningQty()" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['AvailableQty'].touched &&
                    AddOnInfo.controls['Authqty'].hasError('required')
                  ">
                  <ng-container *ngIf="
                      AddOnInfo.controls['AvailableQty'].hasError('required')
                    ">Auth Qty required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['AvailableQty'].touched &&
                    AddOnInfo.controls['AvailableQty'].hasError('pattern')
                  ">
                  Please enter a positive number.
                </mat-error>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Dispatch Qty</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" placeholder="Dispatch Qty" formControlName="DispQty"
                  (blur)="CalculateRemaningQty()" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DispQty'].touched &&
                    AddOnInfo.controls['DispQty'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['DispQty'].hasError('required')">Dispatch qty
                    required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DispQty'].touched &&
                    AddOnInfo.controls['DispQty'].hasError('pattern')
                  ">
                  Please enter a positive number.
                </mat-error>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Remaining Qty</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" placeholder="Remaining Qty" formControlName="Remainingqty" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Remainingqty'].touched &&
                    AddOnInfo.controls['Remainingqty'].hasError('required')
                  ">
                  <ng-container *ngIf="
                      AddOnInfo.controls['Remainingqty'].hasError('required')
                    ">Remaining qty required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Remainingqty'].touched &&
                    AddOnInfo.controls['Remainingqty'].hasError('pattern')
                  ">
                  Please enter a positive number.
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Last filled qty</label>
                <input type="number" class="form-control" placeholder="Last filled Qty"
                  formControlName="Lastfilledqty" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Lastfilledqty'].touched &&
                    AddOnInfo.controls['Lastfilledqty'].hasError('required')
                  ">
                  <ng-container *ngIf="
                      AddOnInfo.controls['Lastfilledqty'].hasError('required')
                    ">Last filled qty required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Lastfilledqty'].touched &&
                    AddOnInfo.controls['Lastfilledqty'].hasError('pattern')
                  ">
                  Please enter a positive number.
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Next fill Qty</label>
                <input type="number" class="form-control" placeholder="Next fill Qty" formControlName="NextFillQty" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['NextFillQty'].touched &&
                    AddOnInfo.controls['NextFillQty'].hasError('required')
                  ">
                  <ng-container *ngIf="
                      AddOnInfo.controls['NextFillQty'].hasError('required')
                    ">Next fill qty required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['NextFillQty'].touched &&
                    AddOnInfo.controls['NextFillQty'].hasError('pattern')
                  ">
                  Please enter a positive number.
                </mat-error>
              </div>
            </div>
            <div class="col-md-1">
              <div class="form-group">
                <label class="small white-space pb-1">Auto refill</label><br />
                <mat-slide-toggle formControlName="AutoRefill"></mat-slide-toggle>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Days Supply</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" placeholder="Days supply" formControlName="DaysSupply"
                  (focusout)="CalculateRemaningDate()" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DaysSupply'].touched &&
                    AddOnInfo.controls['DaysSupply'].hasError('required')
                  ">
                  <ng-container *ngIf="
                      AddOnInfo.controls['DaysSupply'].hasError('required')
                    ">Days Supply required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DaysSupply'].touched &&
                    AddOnInfo.controls['DaysSupply'].hasError('pattern')
                  ">
                  Please enter a positive number.
                </mat-error>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">First Filled date</label>
                <div class="position-relative">
                  <input matInput type="text" formControlName="FirstFilleddate" [matDatepicker]="FirstFilleddate"
                    readonly (click)="FirstFilleddate.open()" class="form-control" />
                  <mat-datepicker-toggle matSuffix [for]="FirstFilleddate" class="date-icon"></mat-datepicker-toggle>
                  <mat-datepicker #FirstFilleddate></mat-datepicker>
                </div>
                <span class="text-danger" *ngIf="AddOnInfo.errors?.dateError">
                  Date must be in the correct order.
                </span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Last Filled date</label>
                <div class="position-relative">
                  <input matInput type="text" formControlName="LastFilleddate" [matDatepicker]="LastFilleddate" readonly
                    (click)="LastFilleddate.open()" class="form-control" />
                  <mat-datepicker-toggle matSuffix [for]="LastFilleddate" class="date-icon"></mat-datepicker-toggle>
                  <mat-datepicker #LastFilleddate></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Fill date</label>
                <div class="position-relative">
                  <input matInput type="text" formControlName="Filldate" [matDatepicker]="Filldate" readonly
                    class="form-control" (click)="Filldate.open()" (dateInput)="CalculateRemaningDate()" />
                  <mat-datepicker-toggle matSuffix [for]="Filldate" class="date-icon"></mat-datepicker-toggle>
                  <mat-datepicker #Filldate></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Fill Expiry Date</label>
                <div class="position-relative">
                  <input matInput type="text" formControlName="FillExpiryDate" [matDatepicker]="FillExpiryDate" readonly
                    (click)="FillExpiryDate.open()" class="form-control" />
                  <mat-datepicker-toggle matSuffix [for]="FillExpiryDate" class="date-icon"></mat-datepicker-toggle>
                  <mat-datepicker #FillExpiryDate></mat-datepicker>
                </div>
              </div>
            </div>
          </div>
          <hr />

          <h3>Payment Detail</h3>
          <div class="row">
            <!-- <div class="col-md-3">
            <div class="form-group">
              <label class="small white-space pb-1">AAC</label>
              <input type="number" class="form-control" formControlName="AAC" />
            </div>
          </div> -->
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Cost</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" formControlName="Cost" (focusout)="setCash()"
                  placeholder="Cost" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Cost'].touched &&
                    AddOnInfo.controls['Cost'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['Cost'].hasError('required')">Cost required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="AddOnInfo.controls['Cost'].touched &&
                    AddOnInfo.controls['Cost'].hasError('pattern')">
                  Please enter a valid amount.
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Markup</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" formControlName="Markup" (focusout)="setCash()"
                  placeholder="Markup" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Markup'].touched &&
                    AddOnInfo.controls['Markup'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['Markup'].hasError('required')">Markup required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="AddOnInfo.controls['Markup'].touched &&
                    AddOnInfo.controls['Markup'].hasError('pattern')">
                  Please enter a valid amount.
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Fee</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" formControlName="Fee" (focusout)="setCash()"
                  placeholder="Fee" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['Fee'].touched &&
                    AddOnInfo.controls['Fee'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['Fee'].hasError('required')">Fee required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="AddOnInfo.controls['Fee'].touched &&
                    AddOnInfo.controls['Fee'].hasError('pattern')">
                  Please enter a valid amount.
                </mat-error>
              </div>
            </div>
            <!-- <div class="col-md-3">
            <div class="form-group">
              <label class="small white-space pb-1">Base Cost</label>
              <input type="number" class="form-control" formControlName="BaseCost" />
            </div>
          </div> -->

            <!-- <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Discount Cost</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" formControlName="DiscountCost" (focusout)="setCash()" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DiscountCost'].touched &&
                    AddOnInfo.controls['DiscountCost'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['DiscountCost'].hasError('required')">Discount Cost
                    required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="AddOnInfo.controls['DiscountCost'].touched &&
                    AddOnInfo.controls['DiscountCost'].hasError('pattern')">
                  Please enter a valid amount.
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Discount Markup</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" formControlName="DiscountMarkup" (focusout)="setCash()" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DiscountMarkup'].touched &&
                    AddOnInfo.controls['DiscountMarkup'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['DiscountMarkup'].hasError('required')">Discount Markup
                    required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="AddOnInfo.controls['DiscountMarkup'].touched &&
                    AddOnInfo.controls['DiscountMarkup'].hasError('pattern')">
                  Please enter a valid amount.
                </mat-error>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Discount Fee</label> <span class="text-danger">*</span>
                <input type="number" class="form-control" formControlName="DiscountFee" (focusout)="setCash()" />
                <mat-error class="ml-3" *ngIf="
                    AddOnInfo.controls['DiscountFee'].touched &&
                    AddOnInfo.controls['DiscountFee'].hasError('required')
                  ">
                  <ng-container *ngIf="AddOnInfo.controls['DiscountFee'].hasError('required')">Discount Fee
                    required</ng-container>
                </mat-error>
                <mat-error class="ml-3" *ngIf="AddOnInfo.controls['DiscountFee'].touched &&
                    AddOnInfo.controls['DiscountFee'].hasError('pattern')">
                  Please enter a valid amount.
                </mat-error>
              </div>
            </div> -->
          </div>
          <hr />

          <h3>Insurance Details</h3>
          <div class="row" [formGroup]="AddInsuranceform">
            <div class="col-md-4">
              <div class="form-group">
                <label class="small white-space pb-1">Insurance</label>
                <mat-form-field>
                  <mat-select class="form-control width" placeholder="Select Insurance"
                    [formControl]="manualForm.get('insurance')" (selectionChange)="onSelectionChange($event)">
                    <mat-option *ngFor="let insurance of insuranceList" [value]="insurance.id">
                      {{ insurance.insurance_provider }}
                    </mat-option>
                    <!-- Add Insurance option -->

                    <div class="add_optionBg">
                      <mat-option (click)="openAddInsuranceModal(selectedUserId)"
                        *ngIf="manualForm.get('patient').value">
                        <div class="d-flex align-items-center text-success f-semibold justify-content-center ">
                          <span _ngcontent-qhx-c296="" class="material-icons mr-2"> add </span> Add Insurance
                        </div>
                      </mat-option>
                    </div>
                    <!-- <mat-option class="hide-checkbox" (click)="openAddInsuranceModal(selectedUserId)"
                    *ngIf="manualForm.get('patient').value">
                    Add Insurance
                  </mat-option> -->
                  </mat-select>
                </mat-form-field>
                <mat-autocomplete #insurance="matAutocomplete">
                  <div class="w-100 h-100 d-flex align-items-center justify-content-center loader"
                    *ngIf="progress_spinner">
                    <span class="purpleLoader"></span>
                  </div>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">Amount</label>
                <input type="number" class="form-control" placeholder="Amount" formControlName="pays" />
                <mat-error class="ml-3" *ngIf="AddInsuranceform.controls['pays'].touched &&
                    AddInsuranceform.controls['pays'].hasError('pattern')">
                  Please enter a valid amount.
                </mat-error>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label class="small white-space pb-1">&nbsp;</label><br />
                <button type="button" class="btn custom-btn btn-sm" (click)="AddInsurance()">
                  Add Insurance
                </button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 mt-2">
              <label>Copay/ Cash Amount : </label>
            </div>
            <div class="col-md-2">
              <input type="number" class="form-control" placeholder="Copay/ Cash Amount" formControlName="Cash"
                (blur)="setCash()" />
              <mat-error class="ml-3" *ngIf="
                  AddOnInfo.controls['Cash'].touched &&
                  AddOnInfo.controls['Cash'].hasError('required')
                ">
                <ng-container *ngIf="AddOnInfo.controls['Cash'].hasError('required')">Copay/ Cash amount
                  required</ng-container>
              </mat-error>
              <mat-error class="ml-3" *ngIf="AddOnInfo.controls['Cash'].touched &&
                    AddOnInfo.controls['Cash'].hasError('pattern')">
                Please enter a valid amount.
              </mat-error>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-6">
              <h3>Copay Amount : <b>{{Copay}}</b></h3>
            </div>
          </div>

          <div class="row mt-3" *ngIf="InsuranceArray.length > 0">
            <div class="col-md-6">
              <table class="table border">
                <thead>
                  <th>Sub plan</th>
                  <th>Pays</th>
                  <th style="width:70px">Action</th>
                </thead>
                <tbody>
                  <tr *ngFor="let Insurance of InsuranceArray; let i = index">
                    <td>{{ Insurance.subplanname }}</td>
                    <td>{{ Insurance.pays }}</td>
                    <td>
                      <button type="button" class="btn btn-danger btn-sm" (click)="RemoveInsurance(i)">
                        X
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer" *ngIf="IsRxsValid">
        <div class="row">
          <div class="col-12 text-right">
            <button type="button" [disabled]="AddOnInfo.invalid" class="custom-btn align-right"
              (click)="AddRxDetailItem()">
              {{RxButton}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="row mt-5">
    <div class="col-12 text-right">
      <button type="submit" class="custom-btn align-right" (click)="AddManualData()">
        Submit
      </button>
    </div>
  </div>
</div>
